import { useEffect, useMemo, useState } from 'react';

function ProgressiveImage({
  src,
  placeholder,
  onFullLoad,
  onError,
  className = '',
  wrapperClassName = '',
  children,
  ...rest
}) {
  const [currentSrc, setCurrentSrc] = useState(placeholder || src || '');
  const [isFullLoaded, setIsFullLoaded] = useState(!src || src === placeholder);

  const effectivePlaceholder = useMemo(() => placeholder || null, [placeholder]);

  useEffect(() => {
    setCurrentSrc(effectivePlaceholder || src || '');
    const shouldSkip = !src || src === effectivePlaceholder;
    setIsFullLoaded(shouldSkip);
    if (shouldSkip) {
      if (shouldSkip && typeof onFullLoad === 'function') {
        onFullLoad();
      }
      return undefined;
    }

    let isCancelled = false;
    const loader = new Image();
    loader.src = src;
    loader.onload = () => {
      if (isCancelled) return;
      setCurrentSrc(src);
      setIsFullLoaded(true);
      if (typeof onFullLoad === 'function') {
        onFullLoad();
      }
    };
    loader.onerror = (event) => {
      if (isCancelled) return;
      setIsFullLoaded(true);
      if (typeof onError === 'function') {
        onError(event);
      }
    };

    return () => {
      isCancelled = true;
    };
  }, [src, effectivePlaceholder, onFullLoad, onError]);

  return (
    <div
      className={`progressive-image-wrapper${wrapperClassName ? ` ${wrapperClassName}` : ''}`}
    >
      <img
        {...rest}
        src={currentSrc}
        className={className}
        data-loaded={isFullLoaded ? 'true' : 'false'}
      />
      {children ? <div className="progressive-image-overlay">{children}</div> : null}
    </div>
  );
}

export default ProgressiveImage;
